import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Renderer from "csi/heading/Renderer";
import html from "csi/html";
import declare from "dojo/_base/declare";

const FilterAttributesPathRenderer = declare(Renderer, {

	/**
	 * @override
	 * Render Path Display Name.
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: Element, actionData): boolean {
		const node = ctx.getNode();
		const { DomainPath } = node;
		html.text(refNode, DomainPath);
		return true;
	},
});

export = FilterAttributesPathRenderer;